import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { PanelInstrucionHands } from '../../../components/common/PanelInstrucionHands';
import { team3_sub3_act_4_01, team3_sub3_act_4_02 } from '../../../assets/imgIntruction/tema3';
import { ModalInfo } from '../../../components/common/ModalInfo';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';


const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	panelInstructionOne: 3,
	panelInstructionTwo: 4,
	panelModalFloor: 5,
	panelModalProducts: 6,
	panelModalSausages: 7,
	panelModalVegetables: 8,
	dialogTwo: 9,
	win: 10
};


const stepThree = {
	clean_floor: steps.panelModalFloor,
	clean_products: steps.panelModalProducts,
	clean_sausages: steps.panelModalSausages,
	clean_vegetables: steps.panelModalVegetables,
};


export const Theme3SubtopicThreeActivityFour = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema3.activities.subtema3], 4);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 sub 3 act 4");
			ObserverEmitter.emit(EVENTS.tema3.topic3.initScene, 4);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_4.sub3_act4_a01T3)
	})

	ObserverEmitter.on(EVENTS.tema3.topic3.actFour.finishActScene, (step = "") => {
		const stepSelect = stepThree[step]
		if (!stepSelect) {
			return
		}
		setUiToShow(stepSelect)

	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema3.topic3.initScene, 4);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 4: Misión final" />
					<DialogBarNew
						dialog={`Tienes una última misión por cumplir en esta Tienda. Selecciona las 4 áreas por mejorar en esta zona para cumplir con inocuidad y limpieza.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel)
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 3: Inocuidad "
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							// ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.introduccion.intro01T2)
							setUiToShow(steps.panelInstructionOne);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.panelInstructionOne && (
				<>
					<PanelInstrucionHands
						text="Toca y arrastra con tu dedo para girar la vista."
						action={() => {
							setUiToShow(steps.panelInstructionTwo);
						}}
						img={team3_sub3_act_4_01}
					/>
				</>
			)}

			{uiToShow === steps.panelInstructionTwo && (
				<>
					<PanelInstrucionHands
						text="Toca encima sobre los objetos para removerlos del piso."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic3.actFour.actScene, "clean_floor")
							setUiToShow(-2);
						}}
						img={team3_sub3_act_4_02}
					/>
				</>
			)}

			{uiToShow === -2 && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.panelModalFloor && (
				<>
					<ModalInfo
						title="Pisos limpios "
						description="Mantén limpio el piso, libre de derrames y manchas."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic3.actFour.actScene, "clean_products")
							setUiToShow(steps.panelModalProducts);
						}}
					/>
				</>
			)}

			{uiToShow === steps.panelModalProducts && (
				<>
					<ModalInfo
						title="Productos recomendados "
						description="Utiliza los productos de limpieza ya que también mantendrán un olor agradable en   la zona."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic3.actFour.actScene, "clean_sausages")
							setUiToShow(-1);
						}}
					/>
				</>
			)}

			{uiToShow === steps.panelModalSausages && (
				<>
					<ModalInfo
						title="Salchichas en malas condiciones"
						description="Muy bien, recuerda que debes retirar las salchichas que se encuentren en mal estado: arrugadas, oscuras o con pérdida de volumen."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic3.actFour.actScene, "clean_vegetables")
							setUiToShow(-1);
						}}
					/>
				</>
			)}

			{uiToShow === steps.panelModalVegetables && (
				<>
					<ModalInfo
						title="Vegetales frescos"
						description="¡Correcto! Debes poner atención a los vegetales. Si notas manchas, mal olor o resequedad debes retirarlos en una bolsa y llevarlos al contenedor de Mermas."
						action={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_4.sub3_act4_a02T3)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actFour.actScene, "init_place")
							setUiToShow(steps.dialogTwo);
						}}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={`¡Excelente trabajo! Has completado las tareas y misiones en la Tienda Receso.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic3.actFour.actScene)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Mantener la limpieza dentro de tu Tienda ayudará a que tanto tú como los Clientes se sientan en un ambiente agradable."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 4,
									pointsWin: 0,
									subtema: tasksId.tema3.activities.subtema3
								})
							);
							navigator("/home3/tema3/subtema3/activityresult");
						}}
					/>
				</>
			)}
		</>
	)
}